(function () {
    'use strict';
    angular.module('swif.ui')
    .controller('ConsumptionImportCSVCtrl', ConsumptionImportCSVCtrl)

    function ConsumptionImportCSVCtrl($scope, $location, swif) {
        var $ctrl = this;
        $ctrl.debug = $location.search().debug ? true : false;
        var resModel = '';
        if ($scope.model.contentType) {
            resModel = swif.data.getModel($scope.model.contentType);
        }
        $ctrl.model = {
            res_model: resModel,
            contentType: $scope.model.contentType,
            encoding: 'UTF-8',
            separator: ';',
            quoting: '"',
            headers: true,
            mapping: []
        };
        // user has to select a file to import to be able to submit form
        $scope.form.$waitAction = true;
        $scope.model._import = $ctrl.model;
        $ctrl.options = {
            target_fields: []
        };
        $ctrl.onChangeFile = onChangeFile;

        function _prepareData () {
            let file_ext = 'text/csv';
            // only for TOTAL consumptions files.
            if ($ctrl.model.file_name.endsWith('.txt')) {
                file_ext = 'text/plain';
            }
            if ($ctrl.model.file_name.endsWith('.xlsx') || $ctrl.model.file_name.endsWith('.xls')) {
                file_ext = 'application/vnd.ms-excel';
            }
            return {
                file_origin: $ctrl.model.file_origin,
                file: $ctrl.model.file_origin,
                res_model: $ctrl.model.res_model,
                file_name: $ctrl.model.file_name,
                file_type: file_ext
            };
        }

        function uploadFile() {
            var defer;
            var data = _prepareData();
            var context = {encoding: $ctrl.model.encoding || ''};
            if (!$ctrl.model.id) {
                // create wizard if not yet created
                defer = swif.data.create('import_csv', data, context)
                    .then(function (data) {
                        // attach id to the model
                        $ctrl.model.id = data.result;
                        document.getElementsByClassName('fa-refresh')[0].classList.add('ng-hide');
                        $scope.form.$waitAction = false;
                        return data;
                    });
            } else {
                // otherwise, update its values
                defer = swif.data.save('import_csv', $ctrl.model.id, data, context)
                    .then(function(data) {
                        document.getElementsByClassName('fa-refresh')[0].classList.add('ng-hide');
                        $scope.form.$waitAction = false;
                        return data;
                    });
            }
            return defer;
        }

        function parsePreview() {
            var userContext = swif.user.getAuthenticatedUser().context;
            var options = {
                encoding: $ctrl.model.encoding || '',
                separator: $ctrl.model.separator || '',
                quoting: $ctrl.model.quoting || '',
                headers: $ctrl.model.headers || false
            };
            return swif.data.callKw(
                'import_csv',
                'parse_preview',
                [$ctrl.model.id, options],
                {count: null, context: userContext}
            ).then(function (data) {
                $ctrl.model.data = data;
                $ctrl.model._data = angular.copy(data);
                $ctrl.model.mapping = [
                    "date",
                    "serial_badge_fuel",
                    "equipment_id",
                    "km",
                    "oil_qtity",
                    "oil_price"
                  ];
            });
        }
        function onChangeFile(newV, filename) {
            $scope.form.$waitAction = true;
            document.getElementsByClassName('fa-refresh')[0].classList.remove('ng-hide');
            if (!newV) {
                return;
            }
            $ctrl.model.file_name = filename || 'import.csv';
            uploadFile();
        }
    }
})();
